/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:24
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-03-16 15:47:23
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\assets\js\authority.js
 */
const buttonAuthorith = {
	addResearch: 'research:saveResearch', // 新建研究
	deleteResearch: 'research:deleteResearchFromRecycleBin', // 删除研究
	recycleResearch: 'research:deleteResearch', // 回收研究
	resetResearch: 'research:resetResearch', // 还原研究
	copyResearch: 'research:copyResearchInfo', // 复制研究
	recycleBin: 'enterRecycleBin', // 回收站
	setting: 'setupResearch', // 设置
	design: 'designResearch', // 设计
	addModelResearch: 'research:saveTemplateResearch', // 新建模板研究
	deleteModelResearch: 'research:deleteTemplateResearch', // 删除模板研究
	resetModelResearch: 'research:resetResearch', // 还原模板研究
	copyModelResearch: 'research:copyTemplateResearchInfo', // 复制模板研究
	copyCustomResearch: 'research:copyAsCustomResearch', // 复制模板研自定义究
	settingModel: 'setupTemplateResearch', // 设置
	designModel: 'designTemplateResearch', // 设计
	exportResearch: 'research:exportResearch', // 导出研究
	dowmLoadResearch: 'researchExcel:download', // 下载研究
	updateCenter: 'center:updateCenter', // 编辑中心
	saveResearchUser: 'researchUser:saveResearchUser', // 添加用户
	updateResearchUser: 'researchUser:updateResearchUser', // 编辑用户
	participateResearch: 'researchParticipation:participateResearch', // 参与研究
	updateFormData: 'formData:saveOrUpdateFormData', // 表单修改
	finishFormData: 'subjectForm:updateToFinished', // 表单置完成
	unlockFormData: 'subjectForm:unlockForm', // 解锁表单
	saveSubjectRecordFile: 'recordFile:saveSubjectRecordFile', // 保存录音
	getSubjectRecordFile: 'recordFile:getSubjectRecordFileVoList', // 获取录音
	deleteSubjectRecordFile: 'recordFile:deleteSubjectRecordFile', // 删除录音
	downLoadSubjectRecordFile: 'recordFile:downLoadSubjectRecordFile', // 下载录音
	addSubject: 'subject:saveSubject', // 添加受试者
	addDonator: 'subject:saveDonator',
	updateSubject: 'subject:updateSubject', // 编辑受试者
	delSubject: 'subject:deleteSubject', // 删除受试者
	statistical: 'statisticalRanking:query' // 消息统计分析
}
export { buttonAuthorith }
